import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#8B6F47", // Light brown
      light: "#A8856B",
      dark: "#5D4E37", // Dark brown
      contrastText: "#fff",
    },
    secondary: {
      main: "#D4AF37", // Gold
      light: "#FFD700",
      dark: "#B8860B",
      contrastText: "#fff",
    },
    background: {
      default: "#FAF8F3",
      paper: "#ffffff",
    },
    text: {
      primary: "#2C2416",
      secondary: "#5D4E37",
    },
    gradient: {
      primary: "linear-gradient(135deg, #8B6F47 0%, #5D4E37 100%)",
      secondary: "linear-gradient(135deg, #D4AF37 0%, #B8860B 100%)",
      success: "linear-gradient(135deg, #A8856B 0%, #8B6F47 100%)",
    },
  },
  typography: {
    fontFamily:
      '"Berlin Sans FB Demi", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "4rem",
      fontWeight: 700,
      color: "linear-gradient(135deg, #D4AF37 0%, #B8860B 100%)",
      "@media (max-width:600px)": {
        fontSize: "2.9rem",
      },
    },
    h2: {
      fontSize: "2.8rem",
      fontWeight: 700,
      color: "#5D4E37",
      "@media (max-width:600px)": {
        fontSize: "2.4rem",
      },
    },
    h3: {
      fontSize: "2.4rem",
      fontWeight: 600,
      color: "linear-gradient(135deg, #D4AF37 0%, #B8860B 100%)",
      "@media (max-width:600px)": {
        fontSize: "1.8rem",
      },
    },
    h4: {
      fontSize: "1.8rem",
      fontWeight: 600,
      "@media (max-width:600px)": {
        fontSize: "1.2rem",
      },
    },
    h5: {
      fontSize: "1.3rem",
      fontWeight: 600,
      "@media (max-width:600px)": {
        fontSize: "1.1rem",
      },
    },
    h6: {
      fontSize: "1.2rem",
      fontWeight: 600,
      "@media (max-width:600px)": {
        fontSize: "1rem",
      },
    },
    body1: {
      fontSize: "1.2rem",
      fontWeight: 600,
      "@media (max-width:600px)": {
        fontSize: "0.95rem",
      },
    },
    body2: {
      fontSize: "1rem",
      fontWeight: 600,
      "@media (max-width:600px)": {
        fontSize: "0.95rem",
      },
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
      letterSpacing: "0.5px",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          padding: "12px 32px",
          fontSize: "1.15rem",
          transition: "all 0.3s ease",
        },
        contained: {
          background: "linear-gradient(135deg, #8B6F47 0%, #5D4E37 100%)",
          boxShadow: "0 4px 15px rgba(139, 111, 71, 0.4)",
          "&:hover": {
            background: "linear-gradient(135deg, #A8856B 0%, #8B6F47 100%)",
            boxShadow: "0 6px 20px rgba(139, 111, 71, 0.6)",
            transform: "translateY(-2px)",
          },
        },
        outlined: {
          borderWidth: 2,
          borderColor: "#8B6F47",
          color: "#8B6F47",
          "&:hover": {
            borderWidth: 2,
            background: "rgba(139, 111, 71, 0.05)",
            borderColor: "#5D4E37",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: "0 8px 32px rgba(93, 78, 55, 0.08)",
          transition: "all 0.3s ease",
          "&:hover": {
            boxShadow: "0 12px 48px rgba(139, 111, 71, 0.15)",
            transform: "translateY(-4px)",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 12,
            "&.Mui-focused fieldset": {
              borderColor: "#8B6F47",
              borderWidth: 2,
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
  },
});

export default theme;
